import { MenuItem, Collapse } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useState, useCallback } from 'react';
import { STRINGS } from '../../constants';
import {
  PRODUCTS_AND_SERVICES_DOMESTIC,
  PRODUCTS_AND_SERVICES_INTERNATIONAL,
  PROHIBITED_LIST,
} from './constants';

const ProductsAndServiceLinks = ({
  title,
  id,
  onMenuItemClick,
  links,
  menuExpanded,
  onClick,
}) => (
  <>
    <MenuItem onClick={() => onClick(id)} sx={{ pl: 3 }}>
      {title}
      {menuExpanded === id ? (
        <ArrowDropUpIcon sx={{ ml: 'auto' }} />
      ) : (
        <ArrowDropDownIcon sx={{ ml: 'auto' }} />
      )}
    </MenuItem>
    <Collapse in={menuExpanded === id}>
      {links.map(link => (
        <MenuItem
          key={link.title}
          onClick={onMenuItemClick}
          href={link.route}
          sx={{ pl: 5 }}
        >
          {link.title}
        </MenuItem>
      ))}
    </Collapse>
  </>
);

const ProductsAndServicesMenu = ({ onMenuItemClick }) => {
  const [menuExpanded, setMenuExpanded] = useState('');

  const onClick = useCallback(
    id => {
      setMenuExpanded(menuExpanded !== id ? id : '');
    },
    [menuExpanded]
  );

  return (
    <>
      <ProductsAndServiceLinks
        id='domestic'
        title={STRINGS.DOMESTIC}
        onClick={onClick}
        onMenuItemClick={onMenuItemClick}
        menuExpanded={menuExpanded}
        links={PRODUCTS_AND_SERVICES_DOMESTIC}
      />
      <ProductsAndServiceLinks
        id='international'
        title={STRINGS.INTERNATIONAL}
        onClick={onClick}
        onMenuItemClick={onMenuItemClick}
        menuExpanded={menuExpanded}
        links={PRODUCTS_AND_SERVICES_INTERNATIONAL}
      />
      <MenuItem
        id='prohibitelList'
        key={PROHIBITED_LIST.title}
        onClick={onMenuItemClick}
        href={PROHIBITED_LIST.route}
        sx={{ pl: 3 }}
      >
        {PROHIBITED_LIST.title}
      </MenuItem>
    </>
  );
};

export default ProductsAndServicesMenu;
